const Flex = ({ children, vertical, className, ...props }) => {
  return (
    <div className={`flex ${vertical ? 'flex-col' : ''} ${className ?? ''}`} {...props}>
      {children}
    </div>
  );
};

export default Flex;
